import { useEffect } from 'react';
import { toast } from 'sonner';
import { useWebSocketContext } from '../contexts/WebSocketContext';

/**
 * App-wide listener that surfaces live WebSocket events as toasts.
 * Renders nothing. New messages are handled inline by MessagesPage + the
 * sidebar counter; here we only toast events that need attention anywhere
 * in the app (deviations).
 */
export default function WebSocketNotifications() {
  const { lastMessage } = useWebSocketContext();

  useEffect(() => {
    if (lastMessage?.type === 'new_deviation') {
      const who = lastMessage.participant_name ? ` — ${lastMessage.participant_name}` : '';
      toast.warning(`Ny avvikelse${who}`, {
        description: lastMessage.typ ? `Typ: ${lastMessage.typ}` : undefined,
      });
    }
  }, [lastMessage]);

  return null;
}
